import { Details } from "@digipost/dds-details-react";
import { Heading } from "@digipost/dds-heading-react";
import { ChangeEvent, FC } from "react";

import Translated from "../infrastructure/Translated";
import { useTranslate } from "../infrastructure/useTranslate";
import styles from "./Postmottak.module.css";
import { TrueFalseRadioButton } from "./TrueFalseRadioButton";

type Props = {
  value: boolean;
  onChange: (value: ChangeEvent<HTMLInputElement>) => void;
};
export const Postmottak: FC<Props> = ({ value, onChange }) => {
  const translate = useTranslate();
  return (
    <>
      <Heading level={2} size={"medium"}>
        <Translated textKey="register.org.motta_digipost" />
      </Heading>
      <p>
        <Translated textKey="register.org.motta_digipost.its_free" />
      </p>
      <TrueFalseRadioButton
        isHorisontal={true}
        name="postmottak"
        value={value}
        change={onChange}
      />
      <Details summary={translate("register.org.motta_digipost.summary")}>
        <p className={styles.firstParagraph}>
          <Translated textKey="register.org.motta_digipost.info" />
        </p>
        <p>
          <Translated textKey="register.org.motta_digipost.info2" />
        </p>
      </Details>
    </>
  );
};
